var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 56,
    viewBox: "0 0 77 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M72.08 53.0758H35.6844C33.947 53.0758 32.5215 51.6467 32.5215 49.9048V4.171C32.5215 2.42918 33.947 1 35.6844 1H72.08C73.8174 1 75.2429 2.42918 75.2429 4.171V49.9048C75.2429 51.6467 73.8174 53.0758 72.08 53.0758Z",
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M68.8723 8.41408V28.1993C68.8723 28.9139 68.2932 29.5392 67.5804 29.5392H40.228C39.5153 29.5392 38.8916 28.9586 38.8916 28.1993V8.41408C38.8916 7.69949 39.4707 7.07422 40.228 7.07422H67.5359C68.2487 7.07422 68.8723 7.65482 68.8723 8.41408Z",
    stroke: "#D6DCE8",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M39.0249 12.8809H68.7383",
    stroke: "#D6DCE8",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M39.0249 17.0791H68.7383",
    stroke: "#D6DCE8",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M39.0249 21.2764H68.7383",
    stroke: "#D6DCE8",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M39.0249 25.4316H68.7383",
    stroke: "#D6DCE8",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M68.8723 8.41408V9.21799H38.8916V8.41408C38.8916 7.69949 39.4707 7.07422 40.228 7.07422H67.5359C68.2487 7.07422 68.8723 7.65482 68.8723 8.41408Z",
    fill: "#D6DCE8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M68.8723 33.4687V45.974C68.8723 46.4207 68.2932 46.8226 67.5804 46.8226H40.228C39.5153 46.8226 38.8916 46.4653 38.8916 45.974V33.4687C38.8916 33.0221 39.4707 32.6201 40.228 32.6201H67.5359C68.2487 32.6201 68.8723 32.9774 68.8723 33.4687Z",
    stroke: "#D6DCE8",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M39.0249 38.4258H68.7383",
    stroke: "#D6DCE8",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M39.0249 42.625H68.7383",
    stroke: "#D6DCE8",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M68.8723 33.96V34.7639H38.8916V33.96C38.8916 33.2454 39.4707 32.6201 40.228 32.6201H67.5359C68.2487 32.6201 68.8723 33.2007 68.8723 33.96Z",
    fill: "#D6DCE8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M59.5619 42.7139L13.6775 54.9066C12.1184 55.3086 10.5146 54.3707 10.1137 52.8075L1.38232 19.847C0.981392 18.2838 1.9169 16.676 3.47607 16.274L49.3604 4.08129C50.9196 3.67933 52.5233 4.61723 52.9242 6.1804L61.6111 39.1409C62.0565 40.7041 61.1656 42.3119 59.5619 42.7139Z",
    fill: "white",
    stroke: "#031849",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M17.9095 30.8778C14.5685 31.7711 11.1383 29.7613 10.2473 26.4116C9.35636 23.062 11.361 19.623 14.7021 18.7298C18.0432 17.8365 21.4734 19.8463 22.3643 23.196C23.2553 26.5456 21.2506 30.0293 17.9095 30.8778ZM15.103 20.293C12.6084 20.9629 11.1383 23.5086 11.8065 26.0097C12.4747 28.5108 15.0139 29.9846 17.5086 29.3147C20.0033 28.6447 21.4734 26.099 20.8052 23.5979C20.1369 21.1415 17.5977 19.623 15.103 20.293Z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M18.1768 30.8334C17.7759 30.9228 17.3304 30.6995 17.1968 30.2975C17.0631 29.8509 17.2859 29.4043 17.7314 29.2703C20.0924 28.511 21.4734 26.0546 20.8052 23.6429C20.1369 21.1418 17.5977 19.6679 15.103 20.3379C12.6084 21.0078 11.1383 23.5535 11.8065 26.0546C11.9401 26.5012 11.6728 26.9478 11.2274 27.0372C10.7819 27.1712 10.3364 26.9032 10.2473 26.4566C9.35636 23.1069 11.361 19.6679 14.7021 18.7747C18.0432 17.8815 21.4734 19.8913 22.3643 23.2409C23.2107 26.4566 21.3843 29.8062 18.1768 30.8334Z",
    fill: "#031849"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M22.2303 47.2704C18.8893 48.1637 15.4591 46.1539 14.5681 42.8042C13.6772 39.4546 15.6818 36.0156 19.0229 35.1224C22.364 34.2291 25.7942 36.2389 26.6851 39.5886C27.5761 42.9382 25.5714 46.4218 22.2303 47.2704ZM19.4238 36.6855C16.9292 37.3555 15.4591 39.9012 16.1273 42.4023C16.7955 44.9033 19.3347 46.3772 21.8294 45.7072C24.3241 45.0373 25.7942 42.4916 25.126 39.9905C24.4577 37.5341 21.9185 36.0156 19.4238 36.6855Z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M16.1273 44.8142C15.7709 44.9035 15.4145 44.7695 15.2363 44.4569C14.9245 43.9656 14.7018 43.385 14.5681 42.8491C13.6772 39.4994 15.6818 36.0604 19.0229 35.1672C21.473 34.4973 24.0568 35.3905 25.616 37.4003C25.8833 37.7576 25.8387 38.2489 25.4823 38.5169C25.126 38.7848 24.6359 38.7402 24.3241 38.3829C23.1659 36.909 21.2503 36.2391 19.4238 36.7304C16.9292 37.4003 15.4591 39.946 16.1273 42.4471C16.2609 42.8937 16.3946 43.2957 16.6173 43.653C16.8401 44.0549 16.7064 44.5462 16.35 44.7695C16.2609 44.7695 16.2164 44.7695 16.1273 44.8142Z",
    fill: "#031849"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M49.3599 22.3938L31.8972 27.0387L28.7788 15.1586L29.8034 14.8906L32.699 25.6988L49.0926 21.3666L49.3599 22.3938Z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M53.6123 38.4732L36.688 42.9648L36.9616 44.001L53.8859 39.5094L53.6123 38.4732Z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M35.0156 22.8399L33.6792 22.7953L33.9019 17.6592L37.1094 14.9348L42.0542 18.2844L44.5043 14.6221L46.4199 14.1309L46.7763 15.4261L45.3507 15.828L42.4106 20.1602L37.1985 16.6319L35.2384 18.2844L35.0156 22.8399Z",
    fill: "#031849"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M35.7988 30.2658L34.5068 30.6084L37.2674 41.0562L38.5594 40.7135L35.7988 30.2658Z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M36.9672 34.748L35.6753 35.0908L37.2485 41.0489L38.5404 40.7061L36.9672 34.748Z",
    fill: "#031849"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M40.4277 29.0197L39.1357 29.3623L41.8963 39.8101L43.1883 39.4675L40.4277 29.0197Z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M41.0458 31.3466L39.7539 31.6895L41.8971 39.8063L43.189 39.4634L41.0458 31.3466Z",
    fill: "#031849"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M45.1001 27.7619L43.8081 28.1045L46.5687 38.5523L47.8607 38.2096L45.1001 27.7619Z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M47.1762 35.7128L45.8843 36.0557L46.5569 38.603L47.8488 38.2601L47.1762 35.7128Z",
    fill: "#031849"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M49.7397 26.5568L48.4478 26.8994L51.2084 37.3472L52.5004 37.0046L49.7397 26.5568Z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M49.999 27.5214L48.707 27.8643L51.215 37.3627L52.5069 37.0198L49.999 27.5214Z",
    fill: "#031849"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.f21edb7dbf2766ad445e75fd784137fe.svg";
export { ForwardRef as ReactComponent };